module.exports = __webpack_public_path__ + "img/banner.a95fad4f.png";